import React, {useEffect, useState} from "react";
import {Col, Row, Statistic, Card} from "antd";
import publicUsersApi from '@api/public-user'
import __i18n from "../../../../intl/__i18n";


function TotalUsersReport() {
  const [state, setState] = useState({
    isFetched: false,
    downloadUrl: "",
    data : []
  });
  
  useEffect(() => {
    fetch()
  }, []);
  
  const fetch = (params={}) => {
    publicUsersApi.getTotalCount({
        params
      })
      .then(({data, meta}) => {
        setState({
          isFetched: true,
          data
        })
      })
      .catch()
  };
  
  return (
    <Row gutter={16}>
      <Col span={12}>
       <Card>
         <Statistic title={__i18n("Total users count")} value={state.data.total_user_count} />
       </Card>
      </Col>
      <Col span={12}>
       <Card>
         <Statistic title={__i18n("Total users in last day")} value={state.data.total_users_in_last_day} />
       </Card>
      </Col>
    </Row>
  )
}

export default TotalUsersReport;

